import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { normalizeQuestionItem } from '../utils/dynamoNormalizer'; // or from same file

function TestContent() {
    const { user, token } = useContext(UserContext);
    const navigate = useNavigate();

    const [questions, setQuestions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [answers, setAnswers] = useState({});
    const [message, setMessage] = useState('Loading...');

    const testId = "CognitiveTest01"; // Or make this dynamic later

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const res = await fetch('https://nzdex6lwb6.execute-api.us-east-1.amazonaws.com/Prod/GetTestQuestions', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ testId })
                });

                const data = await res.json();
                if (res.ok) {
                  //  const cleaned = data.questions.map(normalizeQuestionItem);

                   // setQuestions(cleaned);
                    setQuestions(data.questions);
                    setMessage('');
                } else {
                    setMessage(data.message || 'Failed to load test.');
                }
            } catch (err) {
                setMessage(`Error: ${err.message}`);
            }
        };

        fetchQuestions();
    }, [token]);

    const handleInputChange = (index, choice) => {
        const q = questions[index];
        const key = q.index;
        if (q.answerType === 'single') {
            setAnswers({ ...answers, [key]: [choice] });
        } else {
            const prev = answers[key] || [];
            if (prev.includes(choice)) {
                setAnswers({ ...answers, [key]: prev.filter(c => c !== choice) });
            } else {
                setAnswers({ ...answers, [key]: [...prev, choice] });
            }
        }
    };

    const handleBack = () => {
        setCurrentIndex((prev) => Math.max(0, prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => Math.min(questions.length - 1, prev + 1));
    };

    const handleSubmit = async () => {
        const email = user?.email || localStorage.getItem("email");
        const payload = {
            email:email,        //left side is property name in API, righ side is local variables name that has the value, we are happend to be same here
            testId:testId,
            answers:answers  // the dictionary of { qIndex: [choices] }
        };

        try {
            const res = await fetch("https://mlpnpepuzk.execute-api.us-east-1.amazonaws.com/Prod/SubmitTestAnswers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            alert(`Score: ${data.score.toFixed(2)}%`);
            navigate("/dashboard");
        } catch (err) {
            alert("Submission failed: " + err.message);
        }
    };

    if (message) return <p>{message}</p>;
    if (!questions.length) return <p>No questions found.</p>;

    const current = questions[currentIndex];
    const selected = answers[current.index] || [];
    return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
            <div style={{ maxWidth: '700px', width: '100%', textAlign: 'center' }}>
            <h2>Question {currentIndex + 1} of {questions.length}</h2>

            <div
                    dangerouslySetInnerHTML={{ __html: current.descriptionHtml || '' }}
                    style={{
                        border: '1px solid #ccc',
                        padding: '1rem',
                        marginBottom: '1rem',
                        borderRadius: '4px',
                        backgroundColor: '#f9f9f9',
                        display: 'inline-block',  // center block
                        textAlign: 'left'         // left-align description
                    }}
              />

            <p><strong>{current.questionText}</strong></p>

                <ul
                    style={{
                        listStyle: 'none',
                        padding: 0,
                        marginTop: '1rem',
                        display: 'inline-block',  // center the list box
                        textAlign: 'left'         // left-align each item inside
                    }}
                >
                    {current.answerType === 'single' ? (
                    current.choices.map(choice => (
                        <li key={choice}>
                            <label>
                                <input
                                    type="radio"
                                    name={`q_${current.index}`}
                                    value={choice}
                                    checked={selected.includes(choice)}
                                    onChange={() => handleInputChange(currentIndex, choice)}
                                />
                                {choice}
                            </label>
                        </li>
                    ))
                ) : (
                    current.choices.map(choice => (
                        <li key={choice}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={choice}
                                    checked={selected.includes(choice)}
                                    onChange={() => handleInputChange(currentIndex, choice)}
                                />
                                {choice}
                            </label>
                        </li>
                    ))
                )}
            </ul>

            <div style={{ marginTop: '1rem' }}>
                {currentIndex > 0 && (
                    <button onClick={handleBack}>Back</button>
                )}
                {currentIndex < questions.length - 1 ? (
                    <button onClick={handleNext} style={{ marginLeft: '1rem' }}>Next</button>
                ) : (
                    <button onClick={handleSubmit} style={{ marginLeft: '1rem' }}>Submit</button>
                )}
                </div>
                <p style={{ marginTop: '1rem' }}>{message}</p>
            </div>
        </div>
    );
}

export default TestContent;
